const translations = {
  en: {
    // Navigation
    dashboard: "Dashboard",
    employees: "Employees",
    payroll: "Payroll",
    analytics: "Analytics(Locked)",
    attendance: "Attendance",
    reports: "Reports",
    calendar: "Calendar",
    messages: "Messages",
    EscalationGroupMapping: "Escalation Mapping",
    documentsManagement: "Documents ",
    leaveManagement: "Leave ",
    solfaManagement: "Solfa ",
    employeeChanges: "Employee Changes",
    taxCalculator: "Tax Calculator",
    adminLevels: "Admin Levels",
    departments: "Departments",
    companyConfiguration: "Company Configuration",
    settings: "Settings",

    // Status Messages
    allowLocationAccess: "Please allow location access...",
    accessRestricted: "Access Restricted",
    outsideOfficeArea: "You are currently outside the permitted office area.",
    distanceFromOffice: "Distance from office",
    meters: "meters",
    moveCloserToOffice: "Move closer to the office to unlock",

    // Under Development
    underDevelopment:
      "This page is under development and will be available soon",
    pageName: "Page",
    effectiveManagement:
      "This page will contain all features and tools needed for effective",
    management: "management",

    // Loading
    loadingPermissions: "Loading permissions...",
    logout: "Logout",
    switchEmployee: "Employee View",
    accountActions: "Account Actions",
    accountActionsDescription: "Manage your account and session",
  },
  ar: {
    // Navigation
    dashboard: "لوحة التحكم",
    employees: "الموظفين",
    payroll: "الرواتب",
    analytics: "التحليلات (مقفلة)",
    attendance: "الحضور",
    reports: "التقارير",
    calendar: "التقويم",
    messages: "الرسائل",
    EscalationGroupMapping: "ربط الشكاوي",
    documentsManagement: "إدارة المستندات",
    leaveManagement: "إدارة الإجازات",
    solfaManagement: "إدارة السلف",
    employeeChanges: "تغييرات الموظفين",
    taxCalculator: "حاسبة الضرائب",
    adminLevels: "مستويات الإدارة",
    departments: "الأقسام",
    companyConfiguration: "إعدادات الشركة",
    settings: "الإعدادات",

    // Status Messages
    allowLocationAccess: "الرجاء السماح بالوصول للموقع...",
    accessRestricted: "الوصول محظور",
    outsideOfficeArea: "أنت حاليًا خارج منطقة المكتب المسموح بها.",
    distanceFromOffice: "المسافة من المكتب",
    meters: "متر",
    moveCloserToOffice: "اقترب من المكتب لفتح",

    // Under Development
    underDevelopment: "هذه الصفحة قيد التطوير وستكون متاحة قريبًا",
    pageName: "صفحة",
    effectiveManagement:
      "ستحتوي هذه الصفحة على جميع الميزات والأدوات اللازمة لـ",
    management: "إدارة فعالة",

    // Loading
    loadingPermissions: "جاري تحميل الصلاحيات...",

    logout: "تسجيل الخروج",
    switchEmployee: "عرض الموظف",
    accountActions: "إجراءات الحساب",
    accountActionsDescription: "إدارة حسابك والجلسة",
  },
};

export default translations;